'use client';

import Script from 'next/script';

// Clarityのスクリプトを自前で読み込む方法を採用
// 公式では、GTMを使う方法と`@microsoft/clarity`パッケージを使う方法を提供しているが、以下の理由から採用しなかった
//
// - GTM: UserID をClarityに送信するための、スクリプトの実行順序の管理が難しい。
//    また、ログイン状態でページに訪問してもyuffie側の都合で一瞬だけ未ログインを経由する影響で、UserId が `undefined` になってしまう。
// - `@microsoft/clarity`: ESMモジュールとしてimportを解決できず実行できなかった。パッケージは更新されておらず、ソースコードも公開されていない。
//    - https://github.com/microsoft/clarity/issues/753
//    - https://www.npmjs.com/package/@microsoft/clarity

export const ClarityScript = () => {
  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID}");`,
      }}
      id="clarity-script"
      strategy="afterInteractive"
    />
  );
};
